import React, { useState, useRef } from 'react';
import {
  Alert, Button, Overlay, CloseButton,
} from 'react-bootstrap';
import ObjectiveResource from '../../common/resource/ObjectiveResource';
import { LoadingAnimation } from '../../common/components/Utilities';

function AlertError({ showAlertError, setShowAlertError }) {
  if (!showAlertError) {
    return null;
  }
  return (
    <Alert variant={showAlertError.variant} onClose={() => setShowAlertError(false)} dismissible>
      <p>{showAlertError.message}</p>
    </Alert>
  );
}

function ObjectiveEditDelete({ objectiveId, urlUserObjectives }) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const target = useRef(null);

  const clickConfirm = async () => {
    setLoading(true);
    try {
      const response = await ObjectiveResource.delete(objectiveId);
      if (response === 1) {
        setShowAlertError({
          variant: 'success',
          message: 'Successfully deleted this objective. Redirecting...',
        });
        window.location = urlUserObjectives;
      } else {
        setShowAlertError({
          variant: 'danger',
          message: 'Error while trying to delete this objective. Please try again.',
        });
      }
    } catch (error) {
      setShowAlertError({
        variant: 'danger',
        message: 'Server error while trying to delete this objective. Please try again.',
      });
    } finally {
      setLoading(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      <LoadingAnimation loading={loading} />
      <AlertError showAlertError={showAlertError} setShowAlertError={setShowAlertError} />
      <Overlay target={target.current} show={showOverlay} placement="right">
        {(props) => (
          <div {...props}>
            <span className="pl-3 pr-2">Are you sure?</span>
            <Button variant="primary" onClick={clickConfirm}>Confirm</Button>
            <CloseButton className="p-2 pl-3" onClick={() => setShowOverlay(false)} />
          </div>
        )}
      </Overlay>
      <Button ref={target} type="submit" className="btn btn-danger" onClick={() => setShowOverlay(!showOverlay)}>Delete Objective</Button>
    </>
  );
}

export default ObjectiveEditDelete;
